const baseUrl =
  process.env.NODE_ENV === "production"
    ? "https://priority-api-elite-vacances-production.up.railway.app"
    : "https://priority-api-elite-vacances-production.up.railway.app";

export default baseUrl;
